import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faq } from "@/mocks/community";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="FAQ · 常见问题"
        title="关于吃瓜，你可能想问"
        desc="把大家最常问的几个问题整理在这里，看完能更清楚这个站是怎么运作的。"
        align="center"
      />

      <div className="mt-8 mx-auto max-w-3xl space-y-3">
        {faq.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={item.q}
              className="bg-background-100 border border-background-200 rounded-lg overflow-hidden"
            >
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? null : index)}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 cursor-pointer hover:bg-background-200/60 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900">
                  {item.q}
                </span>
                <i
                  className={`shrink-0 text-lg text-primary-600 transition-transform duration-300 ${
                    isOpen ? "ri-subtract-line" : "ri-add-line"
                  }`}
                />
              </button>
              {isOpen ? (
                <div className="px-5 pb-5 -mt-1">
                  <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </section>
  );
}